import { useCMS, useCMSSafe } from "./use-cms";
import { getTranslation, TranslationKey } from "@/lib/i18n";
import { CMSUILanguage } from "@/lib/cms-types";

export function useI18n() {
  const { uiLanguage } = useCMS();
  
  return {
    t: (key: TranslationKey) => getTranslation(uiLanguage, key),
    language: uiLanguage,
  };
}

export function useI18nSafe() {
  const context = useCMSSafe();
  const language: CMSUILanguage = context?.uiLanguage || "en";
  
  return {
    t: (key: TranslationKey) => getTranslation(language, key),
    language,
  };
}
